var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ims-button',{staticClass:"btn btn-icon main-menu-button",on:{"click":function($event){return _vm.$store.dispatch('interact/sidemenu/toggle')}}},[_c('ims-icon',{attrs:{"icon":"menu","color":"black"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }